import { Button } from '@boi/core/lib';
import React, { useContext } from 'react';

import { isAgent, withPrefix } from '../../helpers';
import UserContext from '../../UserContext';

const className = 'c-PaymentsThankYouPage';
const withClass = withPrefix(className);
const paymentsPageCancelText = `There is a 14-day cooling off period, during which time you can withdraw from contract`;
const payemntPageCancelTextAgent = `Request Policy Cancellation button will send a cancellation request email for this policy to our support team`;

const goToCancelPolicyPage = () => {
  if(isAgent()){
    openOutlook();
  }else{
    window.open('https://digital.bankofireland.com/services/right-to-withdraw','_blank');
  }
};

const openOutlook = () => {
  const to = encodeURIComponent("insurance@boi.com");
  const subject = encodeURIComponent("Policy Cancellation Request");

  const fields = [
    "Customer First Name",
    "Customer Surname",
    "Email Address",
    "Phone Number",
    "Product",
    "Policy Number",
    "Policy Code"
  ];

  const formattedRows = fields.map(field => {
      return `${field}:\t______________________________`;
    });

  const body = formattedRows.join("\n");
  window.location.href = `mailto:${to}?subject=${subject}&body=${encodeURIComponent(body)}`;
};

const PolicyCancellationButton = () => {
  const { agentScriptPending } = useContext(UserContext);
  return <Button
    fluid
    data-ga
    id={`${className}__cancelButton`}
    ariaLabelText={isAgent() ? 'Request Policy Cancellation' : 'Withdraw from Contract'}
    onClick={() => goToCancelPolicyPage()}
    disabled={agentScriptPending}
  >
    {isAgent() ? 'Request Policy Cancellation' : 'Withdraw from Contract'}
  </Button>;
};

export const CancellationCard = () => {
  return (<div className={className} style={{ marginTop: 0, paddingTop: 0 }}>
          <div className={`${className}__thankYouPageTextContainer`}>
          <div className={`${className}__primaryTextContainerOne`}>
              {isAgent() ? payemntPageCancelTextAgent : paymentsPageCancelText}
            </div>
          </div>
          <div className={`${className}__buttonContainer`}>
          <div className={withClass('__buttonSpacing')}>
          <PolicyCancellationButton />
          </div>
          </div>

  </div>);
};
